import React, { useState } from "react";
import { AccommodationDetailsBasic } from "./accommodationSlice";
import { useAuthUser } from "../../features/auth/authHooks";
import { Button } from "react-bootstrap";

const AccommodationDirectLinks = ({
  accommodationDetailsBasic,
}: {
  accommodationDetailsBasic: AccommodationDetailsBasic;
}) => {
  const { isOwnerUser, ownerNumber } = useAuthUser();

  const [copied, setCopied] = useState<string | null>(null);
  const handleCopy = (text: string, id: string) => {
    navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 1500);
  };

  if (!isOwnerUser || accommodationDetailsBasic.slug == null) {
    return <></>;
  }
  const linkFi = `${accommodationDetailsBasic.webStoreUrlFi}?ownerNumber=${ownerNumber}`;
  const linkEn = `${accommodationDetailsBasic.webStoreUrlEn}?ownerNumber=${ownerNumber}`;
  const allFi = `https://www.lomarengas.fi/mokkihaku?ownerNumber=${ownerNumber}`;
  const allEn = `https://www.lomarengas.fi/en/cottage-search?ownerNumber=${ownerNumber}`;

  return (
    <>
      <p>
        <strong>Kohteen suoralinkit</strong>
      </p>

      <p>
        Suomeksi: <br />
        <span className="d-block mb-1">{linkFi}</span>
        <Button
          size="sm"
          variant="btn btn-primary"
          onClick={() => handleCopy(linkFi, "fi")}
        >
          {copied === "fi" ? "Kopioitu!" : "Kopioi leikepöydälle"}
        </Button>
      </p>

      <p>
        Englanniksi: <br />
        <span className="d-block mb-1">{linkEn}</span>
        <Button
          size="sm"
          variant="btn btn-primary"
          onClick={() => handleCopy(linkEn, "en")}
        >
          {copied === "en" ? "Kopioitu!" : "Kopioi leikepöydälle"}
        </Button>
      </p>
      <p>
        <strong>Kaikki kohteet - suoralinkit</strong>
      </p>
      <p>
        Suomeksi: <br />
        <span className="d-block mb-1">{allFi}</span>
        <Button
          size="sm"
          variant="btn btn-primary"
          onClick={() => handleCopy(allFi, "allFi")}
        >
          {copied === "allFi" ? "Kopioitu!" : "Kopioi leikepöydälle"}
        </Button>
      </p>
      <p>
        Englanniksi: <br />
        <span className="d-block mb-1">{allEn}</span>
        <Button
          size="sm"
          variant="btn btn-primary"
          onClick={() => handleCopy(allEn, "allEn")}
        >
          {copied === "allEn" ? "Kopioitu!" : "Kopioi leikepöydälle"}
        </Button>
      </p>
    </>
  );
};
export default AccommodationDirectLinks;
